import React, { useEffect, useState } from "react";
import { Button, ControlLabel, FormControl, FormGroup } from "react-bootstrap";
import { widgetRegistrationSave } from "../../../../../../api/cp";
import { REGISTRATION_BUTTON_TITLE_EN, REGISTRATION_BUTTON_TITLE_RU } from "../constants";

const RegistrationButtonSettings = ({eventWidget, onUpdateSetting}) => {
    const [saving, setSaving] = useState(false);
    const [buttonSettings, setButtonSettings] = useState({
        [REGISTRATION_BUTTON_TITLE_RU]: '',
        [REGISTRATION_BUTTON_TITLE_EN]: '',
    });

    useEffect(() => {
        setButtonSettings({
            [REGISTRATION_BUTTON_TITLE_RU]: eventWidget[REGISTRATION_BUTTON_TITLE_RU] || 'Зарегистрироваться',
            [REGISTRATION_BUTTON_TITLE_EN]: eventWidget[REGISTRATION_BUTTON_TITLE_EN],
        })
    }, [eventWidget]);
    
    const handleSave = async () => {
        try {
            setSaving(true);
            await widgetRegistrationSave(eventWidget.eventId, buttonSettings);
            setSaving(false);

            onUpdateSetting(true);

            const timer = setTimeout(() => { 
                onUpdateSetting(false);
                clearTimeout(timer);
            }, 0);
        } catch (error) {
            console.error(error);
            setSaving(false);
        }
    }

    return (
        <FormGroup>
            <ControlLabel>
                Переименовать кнопку формы регистрации
            </ControlLabel>
            <FormGroup>
                <p>На русском языке:</p>
                <FormControl
                    defaultValue={buttonSettings[REGISTRATION_BUTTON_TITLE_RU] || ''}
                    disabled={saving}
                    onChange={(e) => setButtonSettings({...buttonSettings, [REGISTRATION_BUTTON_TITLE_RU]: e.target.value})}
                />
            </FormGroup>
            <FormGroup>
                <p>На английском языке:</p>
                <FormControl
                    defaultValue={buttonSettings[REGISTRATION_BUTTON_TITLE_EN] || ''}
                    disabled={saving}
                    onChange={(e) => setButtonSettings({...buttonSettings, [REGISTRATION_BUTTON_TITLE_EN]: e.target.value})}
                />
            </FormGroup>
            <Button onClick={handleSave}>
                Сохранить
            </Button>
        </FormGroup>
    );
};

export default RegistrationButtonSettings;
